const HEADING_SELECTOR = 'h1, h2, h3, h4, h5, h6';

export const SECTION_LINK_CONTEXT_MENU_WIDTH = 240;
export const SECTION_LINK_CONTEXT_MENU_HEIGHT = 44;
export const SECTION_LINK_CONTEXT_MENU_PAD = 8;

/**
 * Clamps a fixed-position context menu so it stays inside the viewport with padding.
 */
export function clampSectionLinkMenuPosition(input: {
    clientX: number;
    clientY: number;
    viewportWidth: number;
    viewportHeight: number;
    menuWidth: number;
    menuHeight: number;
    pad?: number;
}): { left: number; top: number } {
    const pad = input.pad ?? SECTION_LINK_CONTEXT_MENU_PAD;
    let left = input.clientX;
    let top = input.clientY;
    left = Math.max(pad, Math.min(left, input.viewportWidth - input.menuWidth - pad));
    top = Math.max(pad, Math.min(top, input.viewportHeight - input.menuHeight - pad));
    return { left, top };
}

/**
 * If the user right-clicked a heading with an id in the skill description (view mode), returns that id.
 * Otherwise returns null (no section-link menu).
 */
export function resolveSectionLinkHeadingFromClickTarget(
    skillId: string | null,
    isEditing: boolean,
    target: EventTarget | null,
): string | null {
    if (!skillId || isEditing) {
        return null;
    }
    if (!(target instanceof HTMLElement)) {
        return null;
    }
    const heading = target.closest(HEADING_SELECTOR);
    if (!heading || !(heading instanceof HTMLElement)) {
        return null;
    }
    const id = heading.id;
    return id || null;
}
